import React, { forwardRef } from 'react';
import logo from "../../Assets/kalam_kids_best_kindergarten_logo.png"; // Assuming logo path is correct relative to this file

const PrintableEnquiryForm = forwardRef(({ data }, ref) => {
    return (
        <div ref={ref} className="bg-white text-gray-800 print:p-0" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {data ? (
                <div className="mx-auto w-[210mm]  p-8 border-2 border-gray-800 relative bg-white box-border print:border-none print:w-full print:h-full">
                    
                    {/* Header */}
                    <div className="flex items-center justify-between border-b-2 border-[#16bab1] pb-4 mb-6">
                        <img src={logo} alt="Kalam Kids Logo" className="h-[8rem] w-[6rem] object-fit" />
                        <div className="text-right">
                            <h1 className="text-[#16bab1] text-2xl font-bold uppercase tracking-wide">
                                Admission Enquiry Form
                            </h1>
                            {/* <p className="text-sm text-gray-600 font-medium">Session: 2026-27</p> */}
                        </div>
                    </div>

                    {/* Student Details */}
                    <div className="mb-6">
                        <h3 className="bg-[#16bab1] text-white px-3 py-1 font-bold text-sm uppercase inline-block rounded-r-md mb-4">
                            Student Details
                        </h3>
                        <div className="grid grid-cols-2 gap-x-12 gap-y-4 px-4">
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-500 font-bold uppercase tracking-wider">Student Name</span>
                                <span className="border-b border-gray-300 py-1 font-semibold text-lg">{data.studentName}</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-500 font-bold uppercase tracking-wider">Gender</span>
                                <span className="border-b border-gray-300 py-1 font-semibold capitalize">{data.gender}</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-500 font-bold uppercase tracking-wider">Date of Birth</span>
                                <span className="border-b border-gray-300 py-1 font-semibold">{data.dob ? data.dob.slice(0, 10) : ''}</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-500 font-bold uppercase tracking-wider">Age</span>
                                <span className="border-b border-gray-300 py-1 font-semibold">{data.age} Years</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-500 font-bold uppercase tracking-wider">Enquiry For</span>
                                <span className="border-b border-gray-300 py-1 font-semibold">{data.admissionFor || 'N/A'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Parent Details */}
                    <div className="mb-6">
                        <h3 className="bg-[#16bab1] text-white px-3 py-1 font-bold text-sm uppercase inline-block rounded-r-md mb-4">
                            Parent's/Guardian's Details
                        </h3>
                        <div className="grid grid-cols-2 gap-x-12 gap-y-6 px-4">
                            {/* Father */}
                            <div className="space-y-4">
                                <h4 className="font-bold text-gray-700 underline decoration-[#16bab1] decoration-2 underline-offset-4">Father</h4>
                                <div className="flex flex-col">
                                    <span className="text-xs text-gray-500 font-bold uppercase">Name</span>
                                    <span className="border-b border-gray-300 py-1 font-medium">{data.fatherName}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-xs text-gray-500 font-bold uppercase">Mobile</span>
                                    <span className="border-b border-gray-300 py-1 font-medium">{data.fatherMobile}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-xs text-gray-500 font-bold uppercase">Email</span>
                                    <span className="border-b border-gray-300 py-1 font-medium">{data.fatherEmail}</span>
                                </div>
                            </div>
                             {/* Mother */}
                             <div className="space-y-4">
                                <h4 className="font-bold text-gray-700 underline decoration-[#16bab1] decoration-2 underline-offset-4">Mother</h4>
                                <div className="flex flex-col">
                                    <span className="text-xs text-gray-500 font-bold uppercase">Name</span>
                                    <span className="border-b border-gray-300 py-1 font-medium">{data.motherName}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-xs text-gray-500 font-bold uppercase">Mobile</span>
                                    <span className="border-b border-gray-300 py-1 font-medium">{data.motherMobile}</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-xs text-gray-500 font-bold uppercase">Email</span>
                                    <span className="border-b border-gray-300 py-1 font-medium">{data.motherEmail}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Address Details */}
                    <div className="mb-8">
                        <h3 className="bg-[#16bab1] text-white px-3 py-1 font-bold text-sm uppercase inline-block rounded-r-md mb-4">
                            Residential Address
                        </h3>
                         <div className="px-4 text-sm font-medium leading-relaxed border border-gray-200 rounded p-4 bg-gray-50">
                            <p>{data.plotNo}, {data.street}</p>
                            <p>{data.landmark}</p>
                            <p>{data.area}</p>
                            <p>{data.city} - {data.state}</p>
                        </div>
                    </div>

                    {/* Branding Footer */}
                    <div className="absolute bottom-8 left-0 right-0 text-center mt-5">
                        <div className="border-t border-gray-300 w-3/4 mx-auto mb-2"></div>
                        <p className="text-[#16bab1] font-bold text-lg">Kalam Kids</p>
                        <p className="text-xs text-gray-500">Smart start. Strong foundation.</p>
                    </div>

                </div>
            ) : (
                <div className="flex justify-center items-center h-screen">
                    <p className="text-gray-500 animate-pulse">Preparing document...</p>
                </div>
            )}
        </div>
    );
});


export default PrintableEnquiryForm;
